import { SplitLine } from '../common';

/* eslint-disable react/prop-types */
export const ItemList = ({
  item, children, itemKey, index,
}) => {
  const { quantity } = item || {};
  if (!quantity) {
    return null;
  }
  const itemList = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < quantity; i++) {
    itemList.push(
      <section key={`${itemKey}_${i}`}>
        {i === 0 || index === 0 ? null : <SplitLine />}
        {children}
      </section>,
    );
  }
  return itemList;
};
